import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';
import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';
import { ProjectScoresDetailsData } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';
import {
  formatUnit,
  getEssSectionName,
  getEssTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareProjectFestivalScoreDetailsDataEss(
  calculateEss: CalculateFestivalEss,
): ProjectScoresDetailsData[] {
  return [
    {
      title: getEssTopicName(EssTopic.PARITY_EQUALITY),
      value: calculateEss.topics.PARITY_EQUALITY.score,
      maxValue: calculateEss.topics.PARITY_EQUALITY.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEssSectionName(EssSection.ARTISTIC_TEAM),
          value:
            calculateEss.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM.score,
          unit: formatUnit(
            calculateEss.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM.maxScore,
          ),
          maxScore:
            calculateEss.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM.maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'ARTISTIC_TEAM',
        },
        {
          name: getEssSectionName(EssSection.OCCASIONAL_OPERATIONAL_TEAM),
          value:
            calculateEss.topics.PARITY_EQUALITY.sections
              .OCCASIONAL_OPERATIONAL_TEAM.score,
          unit: formatUnit(
            calculateEss.topics.PARITY_EQUALITY.sections
              .OCCASIONAL_OPERATIONAL_TEAM.maxScore,
          ),
          maxScore:
            calculateEss.topics.PARITY_EQUALITY.sections
              .OCCASIONAL_OPERATIONAL_TEAM.maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'OCCASIONAL_OPERATIONAL_TEAM',
        },
        {
          name: getEssSectionName(EssSection.PERMANENT_OPERATIONAL_TEAM),
          value:
            calculateEss.topics.PARITY_EQUALITY.sections
              .PERMANENT_OPERATIONAL_TEAM.score,
          unit: formatUnit(
            calculateEss.topics.PARITY_EQUALITY.sections
              .PERMANENT_OPERATIONAL_TEAM.maxScore,
          ),
          maxScore:
            calculateEss.topics.PARITY_EQUALITY.sections
              .PERMANENT_OPERATIONAL_TEAM.maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'PERMANENT_OPERATIONAL_TEAM',
        },
        {
          name: getEssSectionName(EssSection.TRANSPARENCY_MANAGEMENT),
          value:
            calculateEss.topics.PARITY_EQUALITY.sections.TRANSPARENCY_MANAGEMENT
              .score,
          unit: formatUnit(
            calculateEss.topics.PARITY_EQUALITY.sections.TRANSPARENCY_MANAGEMENT
              .maxScore,
          ),
          maxScore:
            calculateEss.topics.PARITY_EQUALITY.sections.TRANSPARENCY_MANAGEMENT
              .maxScore,
          topic: 'PARITY_EQUALITY',
          type: 'ess',
          section: 'TRANSPARENCY_MANAGEMENT',
        },
      ],
    },
    {
      title: getEssTopicName(EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE),
      value: calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
      maxValue: calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEssSectionName(EssSection.ACCESSIBILITY),
          value:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .ACCESSIBILITY.score,
          unit: formatUnit(
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .ACCESSIBILITY.maxScore,
          ),
          maxScore:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .ACCESSIBILITY.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'ACCESSIBILITY',
        },
        {
          name: getEssSectionName(EssSection.RISK_PREVENTION),
          value:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .RISK_PREVENTION.score,
          unit: formatUnit(
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .RISK_PREVENTION.maxScore,
          ),
          maxScore:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .RISK_PREVENTION.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'RISK_PREVENTION',
        },
        {
          name: getEssSectionName(EssSection.COMMUNICATION),
          value:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .COMMUNICATION.score,
          unit: formatUnit(
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .COMMUNICATION.maxScore,
          ),
          maxScore:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .COMMUNICATION.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'COMMUNICATION',
        },
        {
          name: getEssSectionName(EssSection.TEAM_MANAGEMENT),
          value:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .TEAM_MANAGEMENT.score,
          unit: formatUnit(
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .TEAM_MANAGEMENT.maxScore,
          ),
          maxScore:
            calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
              .TEAM_MANAGEMENT.maxScore,
          topic: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
          type: 'ess',
          section: 'TEAM_MANAGEMENT',
        },
      ],
    },
    {
      title: getEssTopicName(EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT),
      value: calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
      maxValue: calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEssSectionName(EssSection.LOCALITY_EMPLOYMENT_PARTNERS),
          value:
            calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .LOCALITY_EMPLOYMENT_PARTNERS.score,
          unit: formatUnit(
            calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .LOCALITY_EMPLOYMENT_PARTNERS.maxScore,
          ),
          maxScore:
            calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .LOCALITY_EMPLOYMENT_PARTNERS.maxScore,
          topic: 'LOCAL_IMPACT_RSE_ENGAGEMENT',
          type: 'ess',
          section: 'LOCALITY_EMPLOYMENT_PARTNERS',
        },
        {
          name: getEssSectionName(EssSection.ECONOMIC_SOCIAL_IMPACT),
          value:
            calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .ECONOMIC_SOCIAL_IMPACT.score,
          unit: formatUnit(
            calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .ECONOMIC_SOCIAL_IMPACT.maxScore,
          ),
          maxScore:
            calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
              .ECONOMIC_SOCIAL_IMPACT.maxScore,
          topic: 'LOCAL_IMPACT_RSE_ENGAGEMENT',
          type: 'ess',
          section: 'ECONOMIC_SOCIAL_IMPACT',
        },
      ],
    },
  ];
}
